import { Box, Button, Stack } from '@mui/material'
import { useState } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { TypeAnimation } from 'react-type-animation'
import './Home.css'

const Home = () => {
  const [rolesVisible, setRolesVisible] = useState(false)

  return (
    <section className='hero' id='bg-image'>
      <Box className='hero__overlay' />
      <Box className='hero__content'>
        <p className='hero__eyebrow'>Violin · Fiddle · Musicology</p>
        <TypeAnimation
          sequence={[
            'Catherine Hall',
            400,
            () => {
              setRolesVisible(true)
            }
          ]}
          wrapper='h1'
          speed={40}
          className='hero__title'
          cursor={false}
        />
        <Box className='hero__roles' aria-live='polite'>
          {rolesVisible && (
            <TypeAnimation
              sequence={[
                'Violinist',
                1200,
                'Instructor',
                1200,
                'Musicologist',
                1200,
                'Irish Traditional Fiddler',
                1200
              ]}
              wrapper='span'
              speed={40}
              deletionSpeed={60}
              className='hero__subtitle'
              repeat={Infinity}
              cursor={false}
            />
          )}
        </Box>
        <Stack
          className='hero__actions'
          direction={{ xs: 'column', sm: 'row' }}
          spacing={2}
          sx={{ mt: 4, opacity: rolesVisible ? 1 : 0, transition: 'opacity 0.6s ease 0.3s' }}
        >
          <Button
            component={RouterLink}
            to='/about'
            variant='contained'
            color='primary'
            size='large'
            sx={{ px: 4, py: 1.25 }}
          >
            About
          </Button>
          <Button
            component={RouterLink}
            to='/contact'
            variant='outlined'
            size='large'
            sx={{
              px: 4,
              py: 1.25,
              borderColor: 'rgba(255, 255, 255, 0.35)',
              color: 'text.primary',
              '&:hover': {
                borderColor: 'primary.main',
                backgroundColor: 'rgba(69, 154, 106, 0.08)'
              }
            }}
          >
            Get in Touch
          </Button>
        </Stack>
      </Box>
    </section>
  )
}

export default Home
